import modular from 'modujs';
import * as modules from './modules';
import globals from './globals';
import { html } from './utils/environment';
import debounce from './utils/debounce';
import gsap from 'gsap/all';
import config from './config';

const app = new modular({
    modules: modules
});

const loaderDurations = {}

window.onunload = () => {
    window.scrollTo(0, 0);
}

window.onload = (event) => {
    // Set html vh size for mobile devices
    if (config.IS_TOUCH) {
        html.style.setProperty(
            '--vh',
            `${window.innerHeight / 100}px`
        )
    }

    const resizeEndEvent = new CustomEvent('resizeEnd');

    window.addEventListener('resize', debounce(() => {
        window.dispatchEvent(resizeEndEvent)
    }, 200, false))

    const $loader = document.getElementById('loader');
    const loaderStyles = window.getComputedStyle($loader)
    loaderDurations.in = parseFloat(loaderStyles.getPropertyValue('--loader-duration-in')) * 1000
    loaderDurations.out = parseFloat(loaderStyles.getPropertyValue('--loader-duration-out')) * 1000

    const intro = new gsap.timeline();
    intro.to('.c-intro_black', { yPercent: 100, delay: 1, ease: 'power3.out', duration: 1.6 })
        .to('.c-intro_orange', { yPercent: 100, delay: -1.4, ease: 'power4.out', duration: 1.4 })
        .to('.c-intro_click span', { yPercent: -100, delay: -0.8, ease: 'power4.out', duration: 1 })

    const loaderAnimation = new Promise(resolve => {
        setTimeout(resolve, 2500);
    })

    // Preload content before than init
    const domLoad = id => {
        return new Promise((resolve, reject) => {
            const $el = document.getElementById(id)
            if ($el === null || $el.isLoaded) {
                resolve();
            } else {
                const loadEvent = $el.tagName === 'VIDEO' ? 'canplaythrough' : 'load'
                $el.addEventListener(loadEvent, () => {
                    resolve()
                });
            }
        })
    }

    Promise.all([loaderAnimation, domLoad('main-css')]).then(init)

};

function init() {
    globals();

    window.scrollTo(0, 0);

    app.init(app)

    html.classList.add('is-loaded')
    html.classList.remove('is-loading')

    document.addEventListener('click', () => {
        html.classList.add('is-ready')
        html.classList.remove('is-first-loaded')
    })
}

